//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import LandingCarousel from 'app_components/modules/LandingCarousel/LandingCarousel'
import SwitchInterestModule from 'app_components/modules/newsEvents/switchInterest'
import PublicAppContainer from 'app_components/layouts/public'
import { Link } from 'react-router-dom'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import CourseSliderModule from 'app_components/modules/CourseSliderModule/CourseSliderModule'
import ReferencesSliderModule from 'app_components/modules/ReferencesSliderModule/ReferencesSliderModule'
//@end

// @import hooks
// @end

// @INFO Import types
import { ILanding, IParamsGetLandingData } from 'app_types/admin/landings/landingTypes'
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService'
// @end

// @INFO Import Styles
import './../studentsScreen.scss'

// @ADD Component types
interface IStudentsScreenLayoutProps {}

const StudentsScreenLayout: React.FC<IStudentsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [landing, updateLanding] = useState<ILanding | undefined>(undefined)

  // @INFO Servicios
  const landingService = new LandingService()

  useEffect(() => {
    getLandingData()
  },[])

  /**
   * @INFO Obtener la data para la landing
   */
  const getLandingData = async () => {
    let httpParams: IParamsGetLandingData = {
      slug: 'student',
      onlyActiveReference: true
    }
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      updateLanding(landingResponse)
    }
  }

  return(
    <PublicAppContainer>
      <div className='students_screen-layout'>
        <TextComponent
          type='subtitle'
        >
          Estudiantes
        </TextComponent>
        {/* ==================================================== */}
        {/* Banners */}
        {/* ==================================================== */}
        <LandingCarousel/>
        {/* ==================================================== */}
        {/* Cursos nuevos */}
        {/* ==================================================== */}
        <CourseSliderModule
          title='Cursos nuevos'
          filter='new'
        />
        {/* ==================================================== */}
        {/* Promociones */}
        {/* ==================================================== */}
        <CourseSliderModule
          title='Promociones'
          filter='discount'
          size={12}
        />
        {/* ==================================================== */}
        {/* Recursos gratuitos */}
        {/* ==================================================== */}
        <SwitchInterestModule />
        <div className="container-body-page">
          {/* ==================================================== */}
          {/* Slider de opiniones */}
          {/* ==================================================== */}
          {landing?.landing?.references && landing?.landing?.references.length > 0 && (
            <ReferencesSliderModule
              title={landing?.landing?.title_references}
              references={landing?.landing?.references}
              random
            />
          )}
          {/* ==================================================== */}
          {/* Programación el linea */}
          {/* ==================================================== */}
          {landing?.landing?.scheduling && landing?.landing?.scheduling?.length > 0 && (
            <>
              {landing?.landing?.scheduling?.length ?
                <div
                  className='container-buttons-sheduling'
                >
                  {landing?.landing?.scheduling.map((_schedule) => (
                    <div className="container-scheduling-item">
                      <TextComponent
                        type='title'
                      >
                        {_schedule.title}
                      </TextComponent>
                      <Link
                        to={{
                          pathname: _schedule.attachedFile
                        }}
                        target='_blank'
                      >
                        <ButtonComponent
                          key={_schedule.unique}
                          variant='secondary'
                          style={{
                            width: 'fit-content'
                          }}
                        >
                          Descargar documento
                        </ButtonComponent>
                      </Link>
                    </div>
                  ))}
                </div>
              :null}
            </>
          )}
        </div>

      </div>
    </PublicAppContainer>
  )
}

export default StudentsScreenLayout
